import { useEffect } from 'react';

/**
 * Custom hook to disable body scroll when a condition is true
 * @param disabled - When true, disables scrolling on the page
 */
export function useDisableScroll(disabled: boolean) {
  useEffect(() => {
    if (!disabled) return;

    const scrollY = window.scrollY;
    const scrollX = window.scrollX;
    const originalBodyOverflow = document.body.style.overflow;
    const originalHtmlOverflow = document.documentElement.style.overflow;

    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = `-${scrollX}px`;
    document.body.style.width = '100%';

    return () => {
      document.body.style.overflow = originalBodyOverflow || '';
      document.documentElement.style.overflow = originalHtmlOverflow || '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.width = '';
      window.scrollTo(scrollX, scrollY);
    };
  }, [disabled]);
}
